import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-import-status-badge',
    templateUrl: './import-status-badge.component.html',
})
export class ImportStatusBadgeComponent {
    @Input() status: string;
}
